import { copyToClipboard } from '@thoughtspot/browser-util';
import { useTranslation } from '@thoughtspot/i18n';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useState } from 'react';
import { V2TranslationKeys } from '../../constants';
import styles from './reset-password-modal.module.scss';
export const ResetPasswordModal = ({ onClose, onConfirm, onGenerateOtp, generatedOtp = '', showOtpLoader = false, otpErrorMessage = '', }) => {
    const { t } = useTranslation();
    const [hasClickedGenerate, setHasClickedGenerate] = useState(false);
    const [localOtp, setLocalOtp] = useState('');
    const [showOtpError, setShowOtpError] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    useEffect(() => {
        setHasClickedGenerate(false);
        setLocalOtp('');
        setShowOtpError(false);
        setIsCopied(false);
    }, []);
    useEffect(() => {
        if (generatedOtp && !localOtp) {
            setLocalOtp(generatedOtp);
        }
    }, [generatedOtp]);
    useEffect(() => {
        if (otpErrorMessage) {
            setShowOtpError(true);
        }
    }, [otpErrorMessage]);
    const handleCopy = () => {
        copyToClipboard(localOtp, () => {
        });
        setIsCopied(true);
    };
    const isSuccess = !!localOtp;
    return (React.createElement(Modal, { isOpen: true, onDismiss: onClose, size: ModalSize.SMALL, title: t(V2TranslationKeys.RESET_PASSWORD), confirmButton: isSuccess
            ? {
                text: t(V2TranslationKeys.CLOSE),
                onConfirm,
            }
            : {
                text: t(V2TranslationKeys.GENERATE_PASSWORD),
                onConfirm: () => {
                    setHasClickedGenerate(true);
                    onGenerateOtp();
                },
                isLoading: showOtpLoader,
                isDisabled: hasClickedGenerate && !showOtpError,
            }, dismissButton: isSuccess
            ? undefined
            : {
                text: t(V2TranslationKeys.CANCEL),
            }, "data-testid": "reset-password-modal" },
        React.createElement(Vertical, { className: styles.modalContent }, isSuccess ? (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "p", noMargin: true, "data-testid": "otp-success-message" }, t(V2TranslationKeys.OTP_GENERATED_SUCCESS)),
            React.createElement(Horizontal, { vAlignContent: "center", className: styles.otpRow },
                React.createElement(Input.Text, { value: localOtp, readOnly: true, className: styles.otpInput, "data-testid": "otp-input" }),
                React.createElement("button", { type: "button", onClick: handleCopy, className: isCopied
                        ? `${styles.copyLink} ${styles.copyLinkCopied}`
                        : styles.copyLink, "data-testid": "copy-otp-button" }, isCopied
                    ? t(V2TranslationKeys.COPIED)
                    : t(V2TranslationKeys.COPY))))) : (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: "p", noMargin: true, "data-testid": "reset-password-warning" }, t(V2TranslationKeys.RESET_PASSWORD_WARNING)),
            showOtpError && (React.createElement(Typography, { variant: "footnote", className: styles.errorText, "data-testid": "otp-error-message" }, t(V2TranslationKeys.OTP_GENERATION_FAILED))))))));
};
//# sourceMappingURL=reset-password-modal.js.map